import template from './layout/app-view.html'
import './app.scss'
import './app.print.scss'

import 'angular-loading-bar/build/loading-bar.min.css'
import 'angular-moment-picker/dist/angular-moment-picker.min.css'
import 'angular-ui-bootstrap-datetimepicker/datetimepicker.css'
import 'ui-select/dist/select.min.css'

let appComponent = {
  template,
  restrict: 'E'
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js